import React from 'react';
import bgImage from '../../../assets/servicebanner/Holiday.webp';

const Breadcrumb = () => {
  return (
    <div className='hero'>
      <img
        src={bgImage}
        alt='breadcrumb background'
        className='hero-img'
      />
      <ul className='breadcumb'>
        <li>Home</li>
        <li>Holidays</li>
      </ul>
    </div>
  );
};

export default Breadcrumb;
